import { IAHU } from '@/Core.Service.Domain/Controls/Controls.Common/types/index.ts';

type AHUState = {
  editAHU: IAHU;
  updateDeleteAHU: boolean;
};

const SET_AHU_EDIT = (state: AHUState, payload: IAHU) => {
  state.editAHU = payload;
};

const SET_AHU_UPDATE_DELETE = (state: AHUState, payload: boolean) => {
  state.updateDeleteAHU = payload;
};

export default {
  SET_AHU_EDIT,
  SET_AHU_UPDATE_DELETE,
};
